import React from "react";
import moment from "moment";

const AzureDeviceItem = ({ device }) => {
  return (
    <ul className="space-y-4 text-base text-gray-800">
      <li>
        <p>
          <span className="font-semibold">Name:</span>{" "}
          {device.displayName || "N/A"}
        </p>
      </li>
      <li>
        <p>
          <span className="font-semibold">Operating System:</span>{" "}
          {device.operatingSystem || "N/A"}
        </p>
      </li>
      <li>
        <p>
          <span className="font-semibold">Operating System Version:</span>{" "}
          {device.operatingSystemVersion || "N/A"}
        </p>
      </li>
      <li>
        <p>
          <span className="font-semibold">Registration Time:</span>{" "}
          {device.azureRegistrationDateTime
            ? moment(device.azureRegistrationDateTime).format(
                "DD/MM/YYYY HH:mm:ss",
              )
            : "N/A"}
        </p>
      </li>
      <li>
        <p>
          <span className="font-semibold">Synced At:</span>{" "}
          {device.syncedAt
            ? moment(device.syncedAt).format("DD/MM/YYYY HH:mm:ss")
            : "N/A"}
        </p>
      </li>
    </ul>
  );
};

export default AzureDeviceItem;
